export default __webpack_public_path__ + "static/media/4.63f43448.png";